// Generate an array of the set length and fill each index with the same data
const generatePlaceholderArray = (len, data) => Array(len).fill(data);

export default generatePlaceholderArray;
